import { put } from 'redux-saga/effects'
import { displayErrorModal } from 'actions/application'
import strings from 'utils/strings'
import { HANDLED } from './constants'

/**
 * Domain handler — EULA acceptance failure.
 *
 * Shows an error modal if the EULA acceptance API call fails, with a message
 * prompting the user to try again.
 *
 * Usage:
 *   import eulaErrorHandler from 'sagas/errorHandlers/eulaErrorHandler'
 *
 *   apiAction({
 *     ...,
 *     errorHandlers: [eulaErrorHandler],
 *   })
 *
 * @param {Error} err - The caught error with `.code` and `.description`.
 * @returns {'handled'}
 */
export default function* eulaErrorHandler(err) {
  const detail =
    err.code || err.description
      ? `${err.code || 'Error'}: ${
          err.description || err.message || 'Unknown error'
        }`
      : err.message || 'Unknown error'
  yield put(
    displayErrorModal(strings.an_error_has_occurred, [
      strings.error_boundary_header,
      detail,
      strings.try_again,
    ])
  )

  return HANDLED
}
